import apiClient from './apiClient';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_BASE_URL = `${BASE_URL}/api/reports`;

export const reportsApi = {
	// Get today's metrics
	getOverview: async (orgId) => {
		try {
			const response = await apiClient.get(`/api/reports/${orgId}/today`);
			return response.data.metrics;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch overview'
			);
		}
	},

	// Get trending data
	getTrends: async (orgId, days = 7, metricTypes = []) => {
		try {
			const response = await apiClient.get(
				`/api/reports/${orgId}/trends`,
				{
					params: {
						days,
						metricTypes,
					},
				}
			);
			return response.data.trends;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch trends'
			);
		}
	},

	// Get historical data
	getHistorical: async (orgId, params = {}) => {
		try {
			const response = await apiClient.get(
				`/api/reports/${orgId}/historical`,
				{ params }
			);
			return response.data.historicalData;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to fetch historical data'
			);
		}
	},

	// Get aggregated metrics
	getMetrics: async (orgId, params = {}) => {
		try {
			const response = await apiClient.get(
				`/api/reports/${orgId}/metrics`,
				{ params }
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch metrics'
			);
		}
	},

	// Generate daily reports
	generateDaily: async (orgId) => {
		try {
			const response = await apiClient.post(
				`${API_BASE_URL}/${orgId}/generate`,
				{},
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			);
			return response.data.metrics;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to generate daily reports'
			);
		}
	},

	// Get reports for a date range
	getReports: async (orgId, startDate, endDate, metricTypes = []) => {
		try {
			const response = await apiClient.get(`${API_BASE_URL}/${orgId}`, {
				params: {
					startDate,
					endDate,
					metricTypes,
				},
				headers: {
					'Content-Type': 'application/json',
				},
			});
			return response.data.metrics;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch reports'
			);
		}
	},

	// Helper function to format date ranges
	getDateRange: (timeRange) => {
		const today = new Date();
		let startDate = new Date();

		switch (timeRange) {
			case 'daily':
				startDate.setDate(startDate.getDate() - 30);
				break;
			case 'monthly':
				startDate.setMonth(startDate.getMonth() - 12);
				break;
			case 'yearToDate':
				startDate = new Date(today.getFullYear(), 0, 1);
				break;
			case 'week':
				startDate.setDate(startDate.getDate() - 7);
				break;
			case 'quarter':
				startDate.setMonth(startDate.getMonth() - 3);
				break;
			default:
				startDate.setDate(startDate.getDate() - 7);
		}

		return {
			startDate: startDate.toISOString().split('T')[0],
			endDate: today.toISOString().split('T')[0],
		};
	},
};
